// Popup shell for the accounting pages (Deposits, Expenses).
//
// Rendered into document.body with fully inline positioning so no global
// .modal / .modal-overlay rule can move or hide it. The box carries the
// "fin-page" class so FinancePages.css keeps styling the buttons, fields and
// tables inside it; the inline styles override the page padding/background
// that class would otherwise bring along.
//
//   level 0 = popup (999998 / 999999)
//   level 1 = popup on top of a popup (1999998 / 1999999)

import React from "react";
import { createPortal } from "react-dom";

const Z = [
  [999998, 999999],
  [1999998, 1999999],
];

const WIDTHS = { sm: 440, md: 620, lg: 1000 };

const DepositsFinModal = ({ onClose, size = "md", level = 0, role = "dialog", children }) => {
  if (typeof document === "undefined") return null;
  const [zOverlay, zBox] = Z[level] || Z[0];
  const width = WIDTHS[size] || WIDTHS.md;

  return createPortal(
    <>
      <div
        onMouseDown={() => onClose && onClose()}
        style={{
          position: "fixed",
          inset: 0,
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0,0,0,.55)",
          zIndex: zOverlay,
        }}
      />
      <div
        className="fin-page"
        role={role}
        aria-modal="true"
        onMouseDown={(e) => e.stopPropagation()}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: zBox,
          width: `min(${width}px, calc(100vw - 24px))`,
          maxWidth: "calc(100vw - 24px)",
          maxHeight: "calc(100vh - 32px)",
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          margin: 0,
          padding: 0,
          boxSizing: "border-box",
          background: "#ffffff",
          border: "1px solid #dbe2ea",
          borderRadius: 12,
          boxShadow: "0 20px 40px rgba(16, 24, 40, 0.25)",
          textAlign: "left",
        }}
      >
        {children}
      </div>
    </>,
    document.body
  );
};

export default DepositsFinModal;
